import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { manualUpdationLog } from "./store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import moment from "moment";
import { fourPlaceHolder } from "modules/utilities/utility";

function StockHistory() {
  const [stockData, setStockData] = useState([]);
  const { fetchManualUpadtion, manualUpdationData, isLoading } =
    manualUpdationLog();
  const [page, newPage] = useState(1);
  useEffect(() => {
    fetchManualUpadtion(page);
  }, [page]);

  useEffect(() => {
    setStockData(manualUpdationData?.updationLogs);
  }, [manualUpdationData]);

  return (
    <>
      <div
        className="scrollable-container"
        style={{ overflowY: "scroll", height: "30rem" }}
      >
        <Table striped bordered hover>
          <thead className="position-sticky top-0 bg-white">
            <tr>
              <th>Note</th>
              <th>Created At</th>
            </tr>
          </thead>
          {isLoading ? (
            <tr>
              <td>{fourPlaceHolder()}</td>
              <td>{fourPlaceHolder()}</td>
            </tr>
          ) : (
            <tbody>
              {stockData?.map((item) => (
                <tr key={item._id}>
                  <td>{item.note}</td>
                  <td>
                    {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>
      </div>
      <PaginationDiv
        paginationData={{
          pageCount: manualUpdationData?.totalPages,
          page: page,
        }}
        newPage={newPage}
        activePage={page}
      />
    </>
  );
}

export default StockHistory;
